<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="bodymatter-rw Part-rw auto-rw page-open-left-rw" epub:type="bodymatter part" id="part001">
<h1 class="part-number"><span href="#/toc#toc-part001" title="Link target outside of Sample">Book One</span></h1>
<h1 class="part-title"><span href="#/toc#toc-part001" title="Link target outside of Sample">COPPER JOHN, 1820–1828</span></h1></section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part001.vue?76a62da0